module.exports = "/assets/gift-events-listing/banner.png?4hRaqLR";